export const COOKIE_CONSENT = 'COOKIE_CONSENT'
export const DEFAULT_PREFERENCES = 'DEFAULT_PREFERENCES'
